var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ loader: true, fadeout: !_vm.isLoading }},[_c('img',{staticClass:"splash-img-logo",attrs:{"src":"/img/logo_color.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }